// extracted by mini-css-extract-plugin
module.exports = {"link":"Unsubscribe_link__bLIgB"};